import { REFETCH_COMMENTS_DATA_REQUEST, REFETCH_COMMENTS_DATA_FAILURE, REFETCH_COMMENTS_DATA_SUCCESS, isCommentsFetchAction, isCommentsPagingAction, isDeepLinkFetchAction, BULK_FETCH_COMMENTS_SUCCESS, BULK_FETCH_COMMENTS_REQUEST, BULK_FETCH_COMMENTS_FAILURE, } from './paging/comments-paging-actions';
import { isCommmentsCrudAction, } from './top-level-comments/top-level-comments-crud-actions';
import { isOfType } from '../../../ts-utils';
import { isRepliesCrudAction } from './replies/replies-crud-actions';
import { isCommmentsReactionAction, } from './reactions/comments-reaction-actions';
import { isMarkCommentAction } from './mark/mark-actions';
import { isCommmentsVoteAction } from './votes/comments-vote-actions';
import { isReportCommentAction } from './report/report-actions';
import { isEffectsAction } from './effects/effects-actions';
import { isRatingsAction } from './ratings/ratings-actions';
import { isLifecycleAction } from './lifecycle/lifecycle-actions';
import { isHistoryAction } from './history/history-actions';
export const isCommentsAction = (action) => {
    return (isCommentsFetchAction(action) ||
        isDeepLinkFetchAction(action) ||
        isCommentsPagingAction(action) ||
        isRepliesCrudAction(action) ||
        isCommmentsCrudAction(action) ||
        isCommmentsReactionAction(action) ||
        isMarkCommentAction(action) ||
        isCommmentsVoteAction(action) ||
        isReportCommentAction(action) ||
        isEffectsAction(action) ||
        isRatingsAction(action) ||
        isLifecycleAction(action) ||
        isHistoryAction(action));
};
export const isRefetchCommentsDataAction = isOfType([
    REFETCH_COMMENTS_DATA_REQUEST,
    REFETCH_COMMENTS_DATA_SUCCESS,
    REFETCH_COMMENTS_DATA_FAILURE,
]);
export const isCommentsBulkFetchAction = isOfType([BULK_FETCH_COMMENTS_SUCCESS, BULK_FETCH_COMMENTS_REQUEST, BULK_FETCH_COMMENTS_FAILURE]);
//# sourceMappingURL=comment-action-types.js.map